import { useState } from "react";

export const BREEDS = [
  "Indie / Indian Pariah",
  "Mixed Breed",
  "Labrador Retriever",
  "Golden Retriever",
  "German Shepherd",
  "Beagle",
  "Pug",
  "Shih Tzu",
  "Pomeranian",
  "Indian Spitz",
  "Siberian Husky",
  "Dachshund",
  "Boxer",
  "Doberman Pinscher",
  "Rottweiler",
  "Great Dane",
  "Dalmatian",
  "Cocker Spaniel",
  "Lhasa Apso",
  "Maltese",
  "Chihuahua",
  "French Bulldog",
  "Yorkshire Terrier",
  "Golden Doodle",
  "Border Collie",
  "Saint Bernard",
  "Pit Bull",
  "Rajapalayam",
  "Mudhol Hound",
  "Chippiparai",
  "Kombai",
  "Rampur Greyhound",
];

export const BreedSelect = ({ label = "Breed", testid = "breed-select", value, onChange }) => {
  const [otherMode, setOtherMode] = useState(() => Boolean(value) && !BREEDS.includes(value));
  return (
    <div>
      <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</label>
      <select
        data-testid={testid}
        value={otherMode ? "Other" : value || ""}
        onChange={(e) => {
          if (e.target.value === "Other") {
            setOtherMode(true);
            onChange("");
          } else {
            setOtherMode(false);
            onChange(e.target.value);
          }
        }}
        className="mt-1.5 w-full rounded-2xl border border-ink/15 bg-cream px-4 py-2.5 text-sm text-ink focus:border-bark focus:outline-none focus:ring-2 focus:ring-bark/25"
      >
        <option value="">Select breed</option>
        {BREEDS.map((b) => (
          <option key={b} value={b}>
            {b}
          </option>
        ))}
        <option value="Other">Other (type it)</option>
      </select>
      {otherMode && (
        <input
          data-testid={`${testid}-other`}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Type the breed"
          className="mt-2 w-full rounded-2xl border border-ink/15 bg-cream px-4 py-2.5 text-sm text-ink placeholder:text-slate-400 focus:border-bark focus:outline-none focus:ring-2 focus:ring-bark/25"
        />
      )}
    </div>
  );
};
